"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import SectionContainer from "@/components/common/SectionContainer";
const services = [{
  title: "WEDDINGS",
  description: "Whether it's an outdoor ceremony near the lake in our white stone gazebo, on the patio...",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/wedding_gazebo.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/wedding_gazebo.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/wedding_gazebo.png-wvc-sizes",
  imageAlt: "Couple at gazebo for wedding ceremony",
  linkText: "Read More>",
  linkUrl: "#"
}, {
  title: "CORPORATE",
  description: "Whether your event is an anniversary, banquet or party we have the perfect environment for an unforgettable experience.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/corporate_centerpiece.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/corporate_centerpiece.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/corporate_centerpiece.png-wvc-sizes",
  imageAlt: "Floral centerpiece on a banquet table",
  linkText: "Read More>",
  linkUrl: "#"
}, {
  title: "EVENTS",
  description: "Plan your next event with a fantastic lake view, plush trees, gardens and other great breath taking views.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/events_banquet.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/events_banquet.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/events_banquet.png-wvc-sizes",
  imageAlt: "Banquet hall set up for an event",
  linkText: "Read More>",
  linkUrl: "#"
}];
export default function GlampingServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}